/**
 * L’objet possède-t-il la propriété ?
 * @param {*} obj
 * @param {string|number} key
 * @returns {boolean}
 */
export default function objectHasProperty(obj, key) {
  return Object.prototype.hasOwnProperty.call(obj, key);
}
